/**
 * src/data/nextSteps.js — CẤU HÌNH "BƯỚC TIẾP THEO" cho mọi trang đích.
 *
 * Sửa file này để đổi gợi ý, không phải sửa từng trang.
 *
 * Mỗi bước là một trong hai dạng:
 *   { tool: 'runway' }                                  → mở công cụ (nhãn lấy tên công cụ)
 *   { to: '/mau', label: 'Mẫu tài chính (Excel)' }       → mở một trang bất kỳ
 * Có thể thêm `label` cho dạng tool để đổi chữ trên nút.
 *
 * Phần tử ĐẦU TIÊN là nút chính (nổi bật). Tối đa hai phần tử sau là liên kết phụ.
 * Phần thừa bị bỏ qua.
 */
import { NEXT } from "./journeys.js";

/* ------------------------------------------------------------------ */
/* 1. Trang công cụ — dùng lại bảng NEXT trong journeys.js              */
/* ------------------------------------------------------------------ */
export const CONG_CU = Object.fromEntries(
  Object.entries(NEXT).map(([id, list]) => [id, list.map((tool) => ({ tool }))]),
);

/* ------------------------------------------------------------------ */
/* 2. Trang từ điển                                                     */
/*    Mặc định: công cụ liên quan đầu tiên của thuật ngữ là nút chính.  */
/*    Ghi thêm ở đây nếu muốn đổi cho một thuật ngữ cụ thể (theo slug).  */
/* ------------------------------------------------------------------ */
export const THUAT_NGU = {
  // "runway": [{ tool: "runway", label: "Tính runway của bạn" }, { tool: "raise-planner" }],
};

/** Khi thuật ngữ không gắn công cụ nào. */
export const THUAT_NGU_MAC_DINH = [
  { to: "/huong-dan/goi-von-lan-dau", label: "Đọc hướng dẫn gọi vốn lần đầu" },
  { to: "/thuat-ngu", label: "Tra thuật ngữ khác" },
];

/* ------------------------------------------------------------------ */
/* 3. Bài Playbook                                                      */
/*    Mặc định: công cụ liên quan ghi trong bài (relatedTools). Bài     */
/*    không có công cụ thì dùng gợi ý theo chủ đề bên dưới.            */
/* ------------------------------------------------------------------ */
export const PLAYBOOK = {
  // "ten-bai": [{ tool: "runway" }, { to: "/mau", label: "Mẫu tài chính" }],
};

export const PLAYBOOK_THEO_CHU_DE = {
  "Tình huống gọi vốn": [{ tool: "readiness-score" }, { to: "/nguon-von", label: "Tìm nguồn vốn phù hợp" }],
  "Góc nhìn quỹ": [{ tool: "fund-match" }, { tool: "pitch-deck" }],
  "Startup Spotlight": [{ to: "/nhan-xet-deck", label: "Gửi deck để được nhận xét" }, { tool: "fund-match" }],
  "Mô hình tài chính": [{ to: "/mau", label: "Tải mẫu mô hình tài chính" }, { tool: "runway" }],
  "Báo cáo tài chính": [{ to: "/mau", label: "Tải mẫu báo cáo tài chính" }, { tool: "runway" }],
  "Chính sách & ưu đãi": [{ to: "/chuong-trinh", label: "Xem chương trình & tài trợ" }, { tool: "legal-checklist" }],
  "Chương trình hỗ trợ nhà nước": [{ to: "/chuong-trinh", label: "Xem chương trình & tài trợ" }, { to: "/nguon-von", label: "Tìm nguồn vốn phù hợp" }],
  "Định giá": [{ tool: "valuation-preseed" }, { tool: "round-simulator" }],
  "Cổ phần & cap table": [{ tool: "cap-table" }, { tool: "founder-equity-split" }],
  "Các loại vốn": [{ tool: "safe-convert" }, { to: "/nguon-von", label: "Tìm nguồn vốn phù hợp" }],
  "Hồ sơ & pitch deck": [{ tool: "pitch-deck" }, { tool: "legal-checklist" }],
  "Tiếp cận nhà đầu tư": [{ tool: "fund-match" }, { to: "/nguon-von", label: "Xem danh mục nguồn vốn" }],
  "Due diligence": [{ tool: "legal-checklist" }, { tool: "cap-table" }],
  "Sai lầm thường gặp": [{ tool: "readiness-score" }, { to: "/nhan-xet-deck", label: "Gửi deck để được nhận xét" }],
  "Câu hỏi của quỹ": [{ tool: "pitch-deck" }, { tool: "fund-match" }],
  "Nhìn lại tuần": [{ to: "/nguon-von", label: "Xem danh mục nguồn vốn" }, { tool: "readiness-score" }],
  "Nhìn lại tháng": [{ to: "/nguon-von", label: "Xem danh mục nguồn vốn" }, { tool: "readiness-score" }],
};

export const PLAYBOOK_MAC_DINH = [
  { tool: "readiness-score" },
  { to: "/nguon-von", label: "Tìm nguồn vốn phù hợp" },
];
